export const sizeData = [
	250,
	500,
	1000,
	2000
];